import React, {useState, useEffect, Fragment} from 'react'
import {Table, Header, Form, TextArea, Label, Menu, Container, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {useFirestore, useFirebase} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {Channelselect} from '../channelselect';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import * as ResultsActions from '../../../actions/canvas/ResultsActions';
import {CanvasNavigation} from '../Navigation'

var moment = require('moment');
require('moment/locale/de');

export default function Results(props){
    const firestore = useFirestore();
    const firebase = useFirebase();
    const dispatch = useDispatch();

    const [activeVersion, setActiveVersion] = useState(null);

    const channel = (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?props.match.params.channel:null;
    const result = (typeof props.match.params.result !== 'undefined' && props.match.params.result.length > 0)?props.match.params.result:null;

    const versions = useSelector(({canvas_results}) => {
        if(channel === null)return [];

        if(typeof canvas_results[channel] === 'undefined')
            return [];
        
        return canvas_results[channel].versions.map((version) => ({id: version, ...canvas_results[channel].mappings[version]}));
    });
    
    const loading = useSelector(({canvas_results}) => {
        if(channel === null)return false;

        if(typeof canvas_results[channel] === 'undefined')return true;
        if(canvas_results[channel].loading)return true;
        return false;
    });

    const draft = useSelector(({canvas_results}) => {
        if(channel === null || typeof canvas_results[channel] === 'undefined')return null;

        return canvas_results[channel].draft;
    });

    const rule = useSelector(({canvas_results}) => {
        if(channel === null || typeof canvas_results[channel] === 'undefined')return null;
        
        return canvas_results[channel].rule;
    });

    useEffect(() => {
        dispatch(ResultsActions.loadVersions(firestore, channel, null));
    }, [channel]);

    let conditions = [];
    let fields = [];

    if(draft !== null && rule !== null && typeof draft.mappings[rule] !== 'undefined' && typeof draft.mappings[rule].conditions !== 'undefined'){
        conditions = draft.mappings[rule].conditions;
    }

    if(conditions.length === 0 || conditions[conditions.length - 1] !== '')
        conditions = [...conditions, ''];

    if(draft !== null && rule !== null && typeof draft.mappings[rule] !== 'undefined' && typeof draft.mappings[rule].fields !== 'undefined'){
        fields = draft.mappings[rule].fields;
    }

    if(fields.length === 0 || fields[fields.length - 1] !== '')
        fields = [...fields, ''];

    return (
        <CanvasNavigation breadcrumb={[
            {
                'caption': 'Ergebnisregeln',
                'href': 'canvas/results/'
            },
            ...(typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?[{            
                'caption': props.match.params.channel,
                'href': 'canvas/results/' + props.match.params.channel
            }]:[],
            ...(draft !== null)?[{            
                'caption': (typeof draft.created === 'undefined' || draft.changed)?'Neuer Entwurf':('Version vom ' + moment(draft.created.toDate()).format('DD.MM.YYYY HH:mm:ss')),
                'href': 'canvas/results/' + props.match.params.channel
            }]:[]
        ]}>
            <div>
                {
                    (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?null
                    :<Channelselect onChannelSelect={(channelId) => {
                        dispatch(RouterActions.push('canvas/results/' + channelId));
                    }} />
                }
                {
                    (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?
                        <div>
                            <Container fluid style={{
                                padding: "20px",
                                overflow: 'auto'
                            }}>
                                {
                                    (draft === null)?
                                        <Menu vertical fluid>
                                            {
                                                versions.map((version) => {
                                                    return <Menu.Item onClick={(e) => {
                                                        dispatch(ResultsActions.createDraftFrom(channel, version.id));
                                                    }}>{
                                                        (typeof version.published !== 'undefined' && version.published)?
                                                            <span><Icon name="star" />Aktive Version vom </span>
                                                        :
                                                            (typeof version.published !== 'undefined')?
                                                                <span><Icon name="history" />Version vom </span>
                                                            :
                                                                <span><Icon name="pencil alternate" />Entwurf vom </span>
                                                    }{moment(version.created.toDate()).format('DD.MM.YYYY HH:mm:ss')}</Menu.Item>
                                                })
                                            }
                                        </Menu>
                                    :
                                        <div>
                                            <div style={{display: 'flex'}}>
                                                <Menu vertical pointing style={{flexGrow: 0}}>
                                                    {
                                                        (Object.keys(draft.mappings).map((ruleKey) => (ruleKey === '_' || ruleKey === '')?null:<Menu.Item active={rule !== null && rule === ruleKey} onClick={(e) => dispatch(ResultsActions.editRule(channel, ruleKey))}>{ruleKey}</Menu.Item>))
                                                    }
                                                    <Menu.Item active={rule === '_' || rule === ''} onClick={(e) => dispatch(ResultsActions.editRule(channel, null))}><Icon name="plus" /><span style={{fontStyle:'italic'}}>Neue Wertung</span></Menu.Item>
                                                </Menu>
                                                <div style={{
                                                    flexGrow: 1,
                                                    padding: "0 2em"
                                                }}>
                                                    {
                                                        (rule !== null && typeof draft.mappings[rule] !== 'undefined')?
                                                            <Form>
                                                                <Form.Input label="Name" value={rule} onChange={(e) => dispatch(ResultsActions.updateRuleField(channel, rule, 'name', e.target.value))} />
                                                                <Form.Field>
                                                                    <label>Beschreibung (intern)</label>
                                                                    <TextArea label="Beschreibung" value={draft.mappings[rule].description} onChange={(e) => dispatch(ResultsActions.updateRuleField(channel, rule, 'description', e.target.value))} />
                                                                </Form.Field>

                                                                <Header as="h4">Bedingungen</Header>
                                                                {
                                                                    conditions.map((condition, idx) => <Form.Input label={(idx + 1) + '. Bedingung'} value={condition} onChange={(e) => dispatch(ResultsActions.updateRuleField(channel, rule, 'conditions.' + idx, e.target.value))}/>)
                                                                }
                                                                <Header as="h4">Werte</Header>
                                                                {
                                                                    fields.map((field, idx) => <Form.Input label={(idx + 1) + '. Wert'} value={field} onChange={(e) => dispatch(ResultsActions.updateRuleField(channel, rule, 'fields.' + idx, e.target.value))}/>)
                                                                }
                                                            </Form>
                                                        :null
                                                    }
                                                </div>
                                            </div>
                                            <div style={{
                                                marginTop: '1em',
                                                display: 'flex'
                                            }}>
                                                <div>
                                                    <Button disabled={!versions.length} onClick={(e) => {dispatch(ResultsActions.cancelCreateDraft(channel))}}>Zurück zur Übersicht</Button>
                                                </div>
                                                <div>
                                                    <Button fluid disabled={typeof draft.from === 'undefined' || draft.from === null || draft.changed} secondary onClick={(e) => dispatch(ResultsActions.publish(firebase, channel, draft.from))}>Entwurf veröffentlichen</Button>
                                                </div>
                                                <div style={{
                                                    flexGrow: 1
                                                }}>
                                                    <Button fluid disabled={!draft.changed} primary onClick={(e) => dispatch(ResultsActions.saveDraft(firestore, channel, draft))}>Entwurf speichern</Button>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </Container>
                        </div>
                    :null
                }
            </div>
        </CanvasNavigation>
    );
}